import { SB } from '@play-co/replicant';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import { getPetAssetKey, speciesChatbot } from './species';

/**
 * Assets for retention messages
 */
export const retentionAssets: Record<string, string> = {
  'retention/d3/ja': 'private/chatbot/retention/retention_d3_ja.png',
  'retention/d3/en': 'private/chatbot/retention/retention_d3_en.png',
};

/**
 * Create retention message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const retentionMessage = createFlexMessageTemplate(
  SB.object({
    locale: SB.tuple(['en', 'ja']),
    species: SB.tuple(speciesChatbot),
  }),
  (args, payload, api) => {
    const altText = getLocaleConfig(args.locale).retention;
    const deadKey = getPetAssetKey(args.species, 'dead');
    const happyKey = getPetAssetKey(args.species, 'happy');

    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`retention/d3/${args.locale}`),
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1:1',
            gravity: 'center',
          },
          {
            type: 'box',
            layout: 'horizontal',
            position: 'absolute',
            width: '100%',
            height: '80%',
            offsetTop: '15%',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: api.getAssetPath(deadKey),
                    aspectMode: 'fit',
                    align: 'center',
                    gravity: 'center',
                  },
                ],
                width: '50%',
                height: '80%',
                justifyContent: 'center',
                alignItems: 'center',
              },
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: api.getAssetPath(happyKey),
                    aspectMode: 'fit',
                    align: 'center',
                    gravity: 'center',
                  },
                ],
                width: '50%',
                height: '80%',
                justifyContent: 'center',
                alignItems: 'center',
              },
            ],
          },
        ],
        paddingAll: '0px',
        justifyContent: 'center',
      },
    });

    return template;
  },
);
